import { createFeatureSelector } from '@ngrx/store';
import { PointsAccountState } from './points-accounts.reducer';

export const getPointsAccountsFeatureState =
  createFeatureSelector<PointsAccountState>('pointsAccount');
